import { feature as topoToGeo } from "topojson-client";
import queryString from "query-string";

const convertTopoIfNeeded = (topologyObjectsName) => (json) => {
    return topologyObjectsName
        ? topoToGeo(json, json.objects[topologyObjectsName])
        : json;
};
const toJSON = (response) => response.json();
const fetchJson = (url) => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
    return (dispatch) => {
        dispatch({ type: "GEOJSON:REQUEST" });
        return fetchJson(url)
            .then(convertTopoIfNeeded(topologyObjectsName))
            .then((geojson) =>
                dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
            )
            .catch((error) =>
                dispatch({ type: "GEOJSON:FAILURE", payload: error })
            );
    };
};

const getSheetId = () => {
    const query = queryString.parse(window.location.search);
    const staging = process.env.REACT_APP_STAGING === "true";

    switch (query.sheetName) {
        case "regional-recovery-map-bushfire-local-economic-recovery-fund-stage-2": {
            return staging
                ? "19zRcQ7CEf79X6CH0EhUEsOZnAEwdL6j5RsWd2k7sIRM" // Staging
                : "1HW-dmn1MePyosqHG4pZRrh__7u6GsqfdgIKDOUSUd1s"; // Prod
        }
        case "regional-recovery-map": {
            return staging
                ? "1croudmcu0w-QTI7-fdLqKbqjG-iUW1ZjGqSPl4QmIuA" // Staging
                : "1j0oOM0guWm5uma73R169qWksRiMs98NVf-wpBqvy7Ds"; // Prod
        }
        case "regional-growth-fund":
        default: {
            return staging
                ? "1TsAH0yaakAwn9XiB5bXtOMj9-wuA56Vufofnk3BdnZI" // Staging
                : "1Xo6hH4tegx_YmDiP3SZRJuKDTiHNZ4hObOqT5aKYHKo"; // Prod
        }
    }
};

export const getAllProjects = () => {
    return (dispatch) => {
        const sheetId = getSheetId();

        dispatch({ type: "PROJECT:ALL:REQUEST" });

        return fetchJson(
            `https://holy-sheet.visualise.today/sheet/${sheetId}?range='Fund Names'`
        )
            .then((json) => {
                const promises = json.map(({ Fund }) =>
                    fetchJson(
                        `https://holy-sheet.visualise.today/sheet/${sheetId}?range='${encodeURIComponent(
                            Fund
                        )}'!A1:Q10000`
                    ).then((data) => ({
                        fundName: Fund,
                        data,
                    }))
                );
                return Promise.all(promises);
            })
            .then((dataForAllFund) => {
                dispatch({
                    type: "PROJECT:ALL:SUCCESS",
                    payload: dataForAllFund,
                });
            })
            .catch((err) => {
                console.log(err);
                dispatch({ type: "PROJECT:ALL:ERROR", payload: err });
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/data.js